/**
 * formatSecondsDuration — friendly duration string from a whole-seconds
 * count (WSRPDM-0013). Contract §0.8: queue ages/durations are integer
 * seconds (`oldestPendingAgeSeconds`, `runningForSeconds`).
 */
export function formatSecondsDuration(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return m > 0 ? `${h}h ${m}m` : `${h}h`;
  if (m > 0) return s > 0 ? `${m}m ${s}s` : `${m}m`;
  return `${s}s`;
}
